import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ContactForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: '', email: '', message: '' });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const validate = () => {
    const e = {};
    if (!values.name.trim()) e.name = t('contact.required');
    if (!values.email.trim()) e.email = t('contact.required');
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) e.email = t('contact.invalidEmail');
    if (!values.message.trim()) e.message = t('contact.required');
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onSubmit = (ev) => {
    ev.preventDefault();
    if (!validate()) return;
    setSubmitting(true);
    // Frontend-only: fire dataLayer event and navigate
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'contact_form_submit' });
    } catch (e) {}
    setTimeout(() => navigate('/thank_you'), 250);
  };

  const onChange = (key) => (e) => {
    setValues((v) => ({ ...v, [key]: e.target.value }));
    if (errors[key]) setErrors((er) => ({ ...er, [key]: undefined }));
  };

  return (
    <form onSubmit={onSubmit} noValidate>
      <div className="flex flex-col gap-5">
        <div>
          <label htmlFor="cf-name" className="field-label">{t('contact.nameLabel')}</label>
          <input
            id="cf-name"
            className="field-input"
            type="text"
            value={values.name}
            onChange={onChange('name')}
            placeholder={t('contact.namePlaceholder')}
            aria-invalid={!!errors.name}
          />
          {errors.name && <div className="field-error">{errors.name}</div>}
        </div>

        <div>
          <label htmlFor="cf-email" className="field-label">{t('contact.emailLabel')}</label>
          <input
            id="cf-email"
            className="field-input"
            type="email"
            value={values.email}
            onChange={onChange('email')}
            placeholder={t('contact.emailPlaceholder')}
            aria-invalid={!!errors.email}
          />
          {errors.email && <div className="field-error">{errors.email}</div>}
        </div>

        <div>
          <label htmlFor="cf-message" className="field-label">{t('contact.messageLabel')}</label>
          <textarea
            id="cf-message"
            className="field-textarea"
            rows={5}
            value={values.message}
            onChange={onChange('message')}
            placeholder={t('contact.messagePlaceholder')}
            aria-invalid={!!errors.message}
          />
          {errors.message && <div className="field-error">{errors.message}</div>}
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p style={{ fontSize: 13, color: 'var(--gd-mineral)' }}>
            {t('contact.altEmail')}{' '}
            <a href="mailto:contacto@geodatosarg.com" className="link-underline" style={{ color: 'var(--gd-navy)', fontWeight: 600 }}>
              contacto@geodatosarg.com
            </a>
          </p>
          <button type="submit" className="btn-primary" disabled={submitting}>
            {t('contact.submit')}
          </button>
        </div>
      </div>
    </form>
  );
}
